import React, { Component } from 'react'
import PropTypes from 'prop-types'
import BlankCard from '../../../../components/ui/cards/BlankCard'
import PersonalityQuestion from './PersonalityQuestion'
import withTour from '../../../../components/hocs/withTour'


class QuestionsWrapper extends Component {
  static propTypes = {
    activeQuestionIndex: PropTypes.number.isRequired,
    goBack: PropTypes.func.isRequired,
    hasPreviousQuestion: PropTypes.bool.isRequired,
    questions: PropTypes.array.isRequired,
    saveAnswer: PropTypes.func.isRequired,
  }

  render() {
    const { hasPreviousQuestion, questions, activeQuestionIndex, saveAnswer, goBack } = this.props
    const progress = parseInt(activeQuestionIndex / (questions.length - 1) * 100, 10)

    return (
      <div className="col-md-8 offset-md-2 p-0">
        {!!questions.length && (
          <div style={{ marginTop: 50 }}>
            <div className="text-center">  { progress === 100? 'Last One!': activeQuestionIndex+1 + ' of 20 Questions'}</div>
            <div className="progress">
              <div
                style={{ width: `${progress}%` }}
                className="progress-bar"
                role="progressbar"
              />
            </div>
            <div id="questionContainer">
              <BlankCard delay={0.5} style={{ marginTop: 20 }}>
                <PersonalityQuestion
                  onSelectAnswer={saveAnswer}
                  question={questions[activeQuestionIndex]}
                />
              </BlankCard>
            </div>
            <div>
              {hasPreviousQuestion && (
                <a className="btn btn-clear" onClick={goBack}>
                  <i className="fal fa-chevron-left"/> Previous
                </a>
              )}
            </div>
          </div>
        )}
      </div>
    )
  }
}

const tourSteps1 = [
  {
    selector: '#questionContainer',
    content: 'Pick the answer that describes you best to complete this quick personality quiz.'
  },
]


export default withTour('personalityQuestions', tourSteps1)(QuestionsWrapper)



// WEBPACK FOOTER //
// ./src/routes/authenticated/PersonalityAssessment/components/QuestionsWrapper.js